import RoutesApp from "./routes"

export default function App() {
  return(
    <div className="app">
      <RoutesApp/>
    </div>
  )
}